import { OrderStatus } from '../types'

export const STATUS_LABELS: Record<OrderStatus, string> = {
  CREEE: 'Créée',
  COLLECTEE: 'Collectée',
  RECUE_DEPOT: 'Reçue au dépôt',
  ATTENTE_NETTOYAGE: 'En attente de nettoyage',
  EN_COURS_NETTOYAGE: 'En cours de nettoyage',
  NETTOYAGE_TERMINE: 'Nettoyage terminé',
  STOCKEE_LIVRAISON: 'Stockée pour livraison',
  EN_TOURNEE: 'En tournée de livraison',
  RETOUR_DEPOT: 'Retour dépôt - À relivrer',
  LIVREE: 'Livrée',
}

export const STATUS_COLORS: Record<OrderStatus, string> = {
  CREEE: 'bg-gray-100 text-gray-800',
  COLLECTEE: 'bg-blue-100 text-blue-800',
  RECUE_DEPOT: 'bg-indigo-100 text-indigo-800',
  ATTENTE_NETTOYAGE: 'bg-yellow-100 text-yellow-800',
  EN_COURS_NETTOYAGE: 'bg-orange-100 text-orange-800',
  NETTOYAGE_TERMINE: 'bg-teal-100 text-teal-800',
  STOCKEE_LIVRAISON: 'bg-purple-100 text-purple-800',
  EN_TOURNEE: 'bg-pink-100 text-pink-800',
  RETOUR_DEPOT: 'bg-red-100 text-red-800',
  LIVREE: 'bg-green-100 text-green-800',
}

export const WORKFLOW_STEPS: OrderStatus[] = [
  'CREEE',
  'COLLECTEE',
  'RECUE_DEPOT',
  'ATTENTE_NETTOYAGE',
  'EN_COURS_NETTOYAGE',
  'NETTOYAGE_TERMINE',
  'STOCKEE_LIVRAISON',
  'EN_TOURNEE',
  'LIVREE',
]

export const NEXT_POSSIBLE_STATUS: Record<OrderStatus, OrderStatus[]> = {
  CREEE: ['COLLECTEE'],
  COLLECTEE: ['RECUE_DEPOT'],
  RECUE_DEPOT: ['ATTENTE_NETTOYAGE'],
  ATTENTE_NETTOYAGE: ['EN_COURS_NETTOYAGE'],
  EN_COURS_NETTOYAGE: ['NETTOYAGE_TERMINE'],
  NETTOYAGE_TERMINE: ['STOCKEE_LIVRAISON'],
  STOCKEE_LIVRAISON: ['EN_TOURNEE'],
  EN_TOURNEE: ['LIVREE', 'RETOUR_DEPOT'],
  RETOUR_DEPOT: ['EN_TOURNEE'],
  LIVREE: [], // Terminal state
}
